/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 78cca1b57a20781b7252a2457a68dee3 */

import { ConcreteRequest } from "relay-runtime";

export type HomepageHoldoutGroup = "consumer" | "control" | "trade" | "%future added value";
export type checkHomepageGroupQueryVariables = {
    userId: string;
};
export type checkHomepageGroupQueryResponse = {
    readonly viewer: {
        readonly homepageUserGroup: HomepageHoldoutGroup | null;
    };
};
export type checkHomepageGroupQuery = {
    readonly response: checkHomepageGroupQueryResponse;
    readonly variables: checkHomepageGroupQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        } as any
    ], v1 = {
        "alias": null,
        "args": [
            {
                "kind": "Variable",
                "name": "userId",
                "variableName": "userId"
            }
        ],
        "kind": "ScalarField",
        "name": "homepageUserGroup",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "checkHomepageGroupQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "checkHomepageGroupQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/checkHomepageGroupQuery",
            "metadata": {},
            "name": "checkHomepageGroupQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '8bc0cf80fe04a4f358a683e4134ac179';
export default node;
